import React from "react";
import PeerToPeer from "../../images/social-iaamarketplace/peer.svg";
import BetterROI from "../../images/social-iaamarketplace/return-on-investment.svg";
import RaiseCapital from "../../images/social-iaamarketplace/capital.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function SolutionMarketplacebenefits() {
  const benefits = [

   
     
    {
      img: PeerToPeer,
      title: "Managing Solutions",
      bodycopy:
      "Managing Solutions offers streamlined oversight and coordination of various tools and applications within the Solution Marketplace, ensuring efficient integration and enhanced performance.",
    },
    {
        img: BetterROI,
        title: "Solution Onboarding Process",
        bodycopy: " The Solution Onboarding Process guides SI partners through the seamless integration of new tools and applications, ensuring proper setup, training, and support for optimal use within the Solution Marketplace."    },
     

        {
          img: RaiseCapital,
          title: "Marketplace",
          bodycopy: " The Marketplace serves as a central hub for SI partners to access a diverse range of solutions and services, fostering collaboration, innovation, and efficient procurement within the Solution Marketplace. "    },
 
          
        ];
  return (
    <div className="">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Benefits
      </h2>
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} className="d-flex"  key={index}>
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
